import { useState } from 'react';

import { useTranslate } from '@/hooks/useTranslate';

import { ConfirmDrawer } from '../Layout/Drawer/ConfirmDrawer';

export interface ErrorMessageProps {
  error: string | null;
  onAcknowledge?: () => void;
}

export function ErrorMessage({ error, onAcknowledge }: ErrorMessageProps) {
  const { t } = useTranslate();
  const [isAcknowledged, setIsAcknowledged] = useState(false);

  const handleAcknowledge = () => {
    setIsAcknowledged(true);
    onAcknowledge?.();
  };

  if (isAcknowledged || !error) {
    return null;
  }

  return (
    <ConfirmDrawer
      title={t('verification.idmission.errors.title')}
      description={error}
      icon="alert"
      iconColor={theme => theme.palette.red[500]}
      primaryAction={handleAcknowledge}
      primaryText={t('verification.idmission.errors.tryAgain')}
      onClose={handleAcknowledge}
    />
  );
}
